import { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { MoreHorizontal } from "lucide-react"

// Rendered on document.body so the table's overflow clipping doesn't hide it.
const RowActions = ({ label = "More actions", items = [] }) => {
  const buttonRef = useRef(null)
  const menuRef = useRef(null)
  const [pos, setPos] = useState(null)

  useEffect(() => {
    if (!pos) return undefined
    const close = (event) => {
      if (menuRef.current?.contains(event.target) || buttonRef.current?.contains(event.target)) return
      setPos(null)
    }
    const onKey = (event) => {
      if (event.key === "Escape") setPos(null)
    }
    const onScroll = () => setPos(null)
    window.addEventListener("mousedown", close)
    window.addEventListener("keydown", onKey)
    window.addEventListener("scroll", onScroll, true)
    return () => {
      window.removeEventListener("mousedown", close)
      window.removeEventListener("keydown", onKey)
      window.removeEventListener("scroll", onScroll, true)
    }
  }, [pos])

  if (!items.length) return null

  const open = (event) => {
    event.stopPropagation()
    const rect = buttonRef.current.getBoundingClientRect()
    setPos({ top: rect.bottom + 4, left: Math.max(8, rect.right - 196) })
  }

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="pc-btn pc-btn--ghost pc-btn--sm"
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={!!pos}
        onClick={open}
      >
        <MoreHorizontal size={16} aria-hidden />
      </button>
      {pos &&
        createPortal(
          <div ref={menuRef} className="bi-menu" role="menu" style={{ top: pos.top, left: pos.left }}>
            {items.map((item) => (
              <button
                key={item.label}
                type="button"
                role="menuitem"
                className={item.highlight ? "is-highlight" : undefined}
                onClick={(event) => {
                  event.stopPropagation()
                  setPos(null)
                  item.onClick()
                }}
              >
                {item.label}
              </button>
            ))}
          </div>,
          document.body
        )}
    </>
  )
}

export default RowActions
